import * as React from "react";
import "./LabelledElement.component.css";
export function LabelledElement({ label, children, horizontal = false }) {
    return (React.createElement("div", { className: `labeled-element ${horizontal ? "labeled-element-horizontal" : ""}` },
        React.createElement("div", { className: "labeled-element-label" }, label),
        React.createElement("div", { className: "labeled-element-content" }, children)));
}
